var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"iconfont-js",style:({ 'font-size': _vm.size + 'px', color: _vm.getColor }),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconClass}})])}
var staticRenderFns = []

export { render, staticRenderFns }